import Vue from 'vue';
import DealDetail from './DealDetail.vue';
import FontAwesomeIcon from '../plugins/font-awesome';

FontAwesomeIcon();

new Vue({
  render: (h) => h(DealDetail),
}).$mount('#vue-deal-detail');
